import * as React from 'react';
function SvgInfo(props) {
    return (<svg width={30} height={30} {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#06F" cx={15} cy={15} r={15}/>
        <path d="M9.581 18.922l1.314.075.343 1.278 3.247.046-.304-1.136 1.314.075.41 1.53a.617.617 0 01-.113.541.63.63 0 01-.406.233l-.097.006-4.546-.063a.621.621 0 01-.557-.361l-.035-.097-.57-2.127zM16.102 8.04c.188.07.33.226.38.418l2.564 9.567a.622.622 0 01-.642.78l-9.857-.563a.62.62 0 01-.565-.457l-.961-3.587a.62.62 0 01.26-.679l8.255-5.416a.63.63 0 01.566-.063zm3.64 6.678l2.39.65-.336 1.195-2.39-.65.336-1.195zm2.088-3.207l.32 1.196-2.414.647-.32-1.196 2.414-.647zm-2.235-3.163l.889.867-1.745 1.759-.888-.867 1.744-1.759z" fill="#FFF" fillRule="nonzero"/>
      </g>
    </svg>);
}
export default SvgInfo;
